import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faPalette } from '@fortawesome/free-solid-svg-icons';

const Experiences = () => {

    const experiences = [
        {
            icon: <FontAwesomeIcon icon={faCode} className="w-6 h-6" />,
            title: "Hitachi Solutions India Pvt Ltd",
            position: "Software Engineer",
            date: "Mar 2025 - Present",
            description: [
                "Designing and implementing scalable AI-driven applications using Microsoft Azure cloud services, developing and experimenting with Generative AI models, Agentic AI, and MCP, building Agentic AI systems leveraging frameworks such as AutoGen and LangChain for multi-agent collaboration, and researching emerging AI technologies while translating experimental prototypes into production-ready solutions.",
            ]
        },
        {
            icon: <FontAwesomeIcon icon={faPalette} className="w-6 h-6" />,
            title: "GUVI Geek Networks, IITM Research Park",
            position: "Intern",
            date: "Mar 2024 - May 2024",
            description: [
                "Secured an internship at Guvi by winning the Guvi Design Hackathon. During the internship, I worked with the product design team, contributing to UI/UX design initiatives. While the internship was primarily focused on design, I also had the opportunity to collaborate with developers and gain insights into the technical aspects of product development, enhancing my understanding of how design and development intersect in creating user-centric solutions.",
            ]
        }
    ];

    // {
    //     icon: <FontAwesomeIcon icon={faPalette} className="w-6 h-6" />,
    //     title: "UI/UX Designer",
    //     position: "Dan Jr. Wedding Biryani",
    //     date: "1/2024 - 1/2024",
    //     description: [
    //         "Designed and implemented a responsive web UI/UX for Dan Jr. Wedding Biryani's biryani ordering platform using Figma and Canva, collaborating with developers to ensure seamless integration and adherence to client specifications for optimal usability.",
            
    //     ]
    // },
    return (
        <section id="experiences" className="relative py-28 bg-gray-900">
            <div className="relative z-10 max-w-screen-xl mx-auto px-4 text-gray-300 justify-between gap-24 lg:flex md:px-8">
                <div className="max-w-xl">
                    <h3 className="text-white text-3xl font-semibold sm:text-4xl">
                     Professional Experience
                    </h3>
                  
                </div>
                <div className="mt-12 lg:mt-0">
                    <ul className="grid gap-8 sm:grid-cols-2">
                    {
    experiences.map((experience, idx) => (
        <li key={idx} className="flex gap-x-4">
            <div className="flex-none w-12 h-12 bg-customYellow text-white rounded-lg flex items-center justify-center">
                {experience.icon}
            </div>
            <div>
                <h4 className="text-lg text-gray-100 font-semibold">
                    {experience.title}
                </h4>
                <p className="mt-3">
                    {experience.position} | {experience.date}
                </p>
                <ul className="mt-3 text-gray-300">
                    {experience.description.map((point, index) => (
                        <li key={index}>{point}</li>
                    ))}
                </ul>
            </div>
        </li>
    ))
}

                    </ul>
                </div>
            </div>
            <div className="absolute inset-0 max-w-md mx-auto h-72 blur-[118px]" style={{ background: "linear-gradient(152.92deg, rgba(192, 132, 252, 0.2) 4.54%, rgba(232, 121, 249, 0.26) 34.2%, rgba(192, 132, 252, 0.1) 77.55%)" }}></div>
        </section>
    )
}

export default Experiences;